<app-alert></app-alert>

<div class="delete-account">
  <!-- Warning banner (desktop) -->
  <div class="delete-account__banner">
    <i class="fa fa-info-circle delete-account__banner-icon"></i>
    <p class="delete-account__banner-text">
      {{ 'global.warning-message-delete-account' | translate }}
      {{ 'global.message-delete-account' | translate }}
    </p>
  </div>

  <!-- Confirmation form -->
  <form #deleteForm="ngForm" class="delete-account__form" [formGroup]="myDeleteForm">
    <div class="delete-account__field">
      <label class="delete-account__label" for="email">
        {{ 'global.mail' | translate }}
      </label>
      <input
        id="email"
        class="delete-account__input"
        type="email"
        formControlName="email"
        placeholder="{{ 'delete-account-page.email-placeholder' | translate }}" />
    </div>

    <div class="delete-account__field">
      <label class="delete-account__label" for="password">
        {{ 'global.password' | translate }}
      </label>
      <div class="delete-account__input-wrap">
        <input
          id="password"
          class="delete-account__input"
          formControlName="password"
          [type]="isConfirmPasswordVisible ? 'text' : 'password'"
          placeholder="{{ 'delete-account-page.password-placeholder' | translate }}"
          minlength="4"
          maxlength="16"
          autocomplete="off" />
        <span class="delete-account__view">
          <app-agres-icons
            [ngClass]="isConfirmPasswordVisible ? 'agres-eye' : 'agres-eye-off'"
            (click)="confirmTogglePassword()"></app-agres-icons>
        </span>
      </div>
    </div>

    <div class="delete-account__actions">
      <app-button
        (btnClick)="onDeleteUser()"
        type="submit"
        color="danger"
        icon="agres-delete"
        title="{{ 'delete-account-page.delete-permanently' | translate }}"></app-button>
      <a class="delete-account__cancel" (click)="backToProfile()">
        {{ 'delete-account-page.cancel-back' | translate }}
      </a>
    </div>
  </form>

  <!-- Export data card -->
  <div class="delete-account__export">
    <div class="delete-account__export-info">
      <h3 class="delete-account__export-title">
        {{ 'privacy.export-all-title' | translate }}
      </h3>
      <p class="delete-account__export-desc">
        {{ 'privacy.export-all-description' | translate }}
      </p>
    </div>
    <app-button
      type="button"
      color="return"
      icon="agres-download"
      [disabled]="downloadingAllData"
      (btnClick)="downloadAllMyData()"
      title="{{
        (downloadingAllData ? 'privacy.export-all-loading' : 'privacy.export-all-button') | translate
      }}"></app-button>
  </div>
</div>
